<template>
  <div class="tabscheduleVue">
    <!-- Individual calls section area -->
    <div class="o-ndividualArea">
        <div class="o-ndividualTable" v-loading="loading">
            <div v-for="(schedule,index) in scheduleList" :key="index" class="o-custom-table-container c-common-box-shadow c-radius3 schedule-list-table-align">
                <div>
                    <div class="o-calls-table c-common-gradient">
                        <div class="calls-table-row phonesheet-table-row">

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Date:</span>
                                            <div>{{getDate(schedule.start)}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Call:</span>
                                            <div>{{getTime(schedule.start)+" - "+getTime(schedule.end)}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Client:</span>
                                            <div>
                                                <div>{{schedule.job&&schedule.job.client&&schedule.job.client.subdomain?schedule.job.client.subdomain:''}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Event:</span>
                                            <div>
                                            <a @click="openCloseJobInfoModal('open', schedule.job);">{{schedule.job?schedule.job.title:''}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Position:</span>
                                        <div>{{schedule.skill.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell" v-if="display_rate">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Rate/hr:</span>
                                        <div>{{ schedule.rate?'$ '+schedule.rate:'' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="schedule.status.name != 'Confirmed'" class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Call Timeout:</span>
                                        <div>{{getCallOutTime(schedule.assigned_at)}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Status:</span>
                                        <div>{{schedule.status.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell notes-scroll-view-style">
                                        <span class="">Notes:</span>
                                    <div>{{schedule.notes}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div> <!-- class="table-td-border-right" -->
                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                        <span class="">Job Location:</span>
                                        <div class="notify-icon o-red-icon">
                                        <a href="javascript: void(0)" @click="selectedJob = schedule.job; openMap();"><i class="fa fa-map-marker" aria-hidden="true"></i></a> 
                                        </div>
                                        <div style="font-size: 11px;">{{schedule.job&& schedule.job.venue && schedule.job.venue.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                        <span class="">Report:</span>
                                        <div v-if="schedule.job && schedule.job.report ? schedule.job.report.length>0 : ''" class="notify-icon o-green-icon">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </div>

                                        <div v-if="schedule.job && schedule.job.report && schedule.job.report.length==0" class="notify-icon o-red-icon">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                        <span class="">HW:</span>
                                        <div v-if="schedule.job && schedule.job.hw && schedule.job.hw.length>0" class="notify-icon o-green-icon">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </div>

                                        <div v-if="schedule.job && schedule.job.hw && schedule.job.hw.length==0" class="notify-icon o-red-icon">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="o-table-extend-area u-pad-all-5 text-left">
                        <ul class="o-table-extend">
                            <li>
                                <a href="javascript: void(0)" :class="(internetConfirm == true || schedule.status.name == 'Confirmed' || !getPower('scheduleActions') || !checkCallClientAndLoggedInUserClient(schedule.job.client.id))?'disabled':''" @click="checkOtherBookingConflict(schedule)" class="o-confirm-icon"><i class="fa fa-check-circle" aria-hidden="true"></i> Confirm
                                <span class="otb-flag" v-if="schedule.mua_booking_conflict&&schedule.mua_booking_conflict.length"> OTB {{" - " + schedule.mua_booking_conflict[0] }} </span>
                                <!-- <span class="otb-flag"> OTB {{" - Tristate" }} </span> -->
                                </a>
                            </li>
                            <li v-if="schedule.status.name != 'Confirmed' && pass_option == false">
                                <a href="javascript: void(0)" :class="(internetConfirm == true || !getPower('scheduleActions') || !checkCallClientAndLoggedInUserClient(schedule.job.client.id) )?'disabled':''" @click="passCall(schedule)" class="o-pass-icon"><i class="fa fa-share-square-o" aria-hidden="true"></i> Pass</a>
                            </li>
                            <li v-if="schedule.status.name != 'Confirmed'">
                                <a href="javascript: void(0)" :class="(internetConfirm == true || !getPower('scheduleActions') || !checkCallClientAndLoggedInUserClient(schedule.job.client.id))?'disabled':''" @click="declineCall(schedule)" class="o-decline-icon"><i class="fa fa-times" aria-hidden="true"></i> Decline</a>
                            </li>
                            <li v-if="schedule.status.name == 'Confirmed' && userRoleSlug!='employee'">
                                <a href="javascript: void(0)" :class="(internetConfirm == true || !getPower('scheduleActions')|| !checkCallClientAndLoggedInUserClient(schedule.job.client.id))?'disabled':''" @click="callOut(schedule)" class="o-decline-icon"><i class="fa fa-times" aria-hidden="true"></i> Call out</a>
                            </li>
                            <li v-if="userRoleSlug!='employee'">
                                <a href="javascript: void(0)" :class="(internetConfirm == true || !getPower('scheduleActions')||!checkCallClientAndLoggedInUserClient(schedule.job.client.id))?'disabled':''" @click="clearAssign(schedule)" class="o-clear-icon"><i class="fa fa-trash" aria-hidden="true"></i> Clear</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" :class="(internetConfirm == true || !getPower('scheduleActions')|| !checkCallClientAndLoggedInUserClient(schedule.job.client.id))?'disabled':''" @click="findCarpool(schedule)" class="o-clear-icon"><i class="fa fa-taxi" aria-hidden="true"></i> 
                                    Find Carpool 
                                    <!-- {{  internetConfirm + '  ' + !getPower('scheduleActions') }} -->
                                </a>
                            </li>

                            <!-- <li v-if="schedule.status.name != 'Confirmed'">
                                <a class="o-pass-icon"> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Call Timeout : {{getCallOutTime(schedule.assigned_at)}}</a>
                            </li> -->
                        </ul>
                    </div>
                </div>

            </div>

            <div v-if="scheduleList.length <= 0 && afterAPI ==true" class="">
                <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                    <div class="col-md-12 no-job-dispaly">
                       <!-- <i class="fa fa-frown-o" aria-hidden="true"></i>
                       <br />
                        No Data Stored -->
                        Please Stand By<br />
                        We are looking for your next job<br />
                        Check Back Soon<br />
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- /Individual calls section area -->
    <!-- <div selectedJobselectedJob> -->
        <modal name="calender-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom" @closed="onHidden">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header text-center" v-if="selectedJob">
                            <button @click="selectedJob = null; closeMap();" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 class="modal-title">Event : {{selectedJob.title}}</h1> </div>
                        <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender" v-if="selectedJob">
                            <form>

                                <div class="row">
                                    <div class="col-sm-12 o-no-padding o-calender-container">

                                        <!-- <div class="col-md-5 o-right-no-padding o-calender-area">
                                            <div class="o-calls-table">
                                            <div class="o-calender-details-list">
                                                <ul class="">
                                                    <li><strong>Job No.</strong> <span>#{{this.modal_event.job_number}}</span></li>
                                                    <li><strong>Created by:</strong> <span>{{this.modal_event.created_by}}</span></li>
                                                    <li><strong>Start Date:</strong> <span>{{this.modal_event.start}}</span></li>
                                                    <li><strong>End Date:</strong> <span>{{this.modal_event.end}}</span></li>
                                                    <li><strong>Employer:</strong> <span>{{this.modal_event.hiring_organization}}</span></li>
                                                    <li><strong>Payroll:</strong> <span>{{this.modal_event.payroll}}</span></li>
                                                </ul>
                                            </div>
                                            <div class="o-calender-wishlist">
                                                <a @click="viewCalendarCall(modal_event.id)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-yellow">View calls</a>
                                            </div>
                                            
                                            </div>
                                        </div> -->
                                        <div class="col-md-7 o-calender-area">
                                        
                                            <div class="custom-row u-common-box-shadow c-radius3">
                                                <div class="o-calls-table">
                                                    <div class="o-common-head">
                                                        <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i>
                                                        Venue: {{getAddressText(selectedJob.venue)}}
                                                        </h5>
                                                    </div>
                                                    <div class="o-map-conatiner">
                                                        <iframe 
                                                            width="100%"
                                                            height="100%"
                                                            frameborder="0" style="border:0"
                                                            :src="getMapUrl()" allowfullscreen>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </form>
                        </div>

                            <div class="modal-footer text-center">
                                <!-- <ul class="o-filter-area">
                                    <li>
                                        <button @click="closeCalenderDetals()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                                    </li>
                                    <li>
                                        <button type="button" @click="scheduleWishlist()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" ><i class="fa fa-star" aria-hidden="true"></i> Wishlist</button>
                                    </li>
                                </ul> -->
                            </div>

                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
        </modal>

        <modal name="calender-job-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom" @closed="onHidden">
            <div tabindex="-1" role="dialog" >
                <div role="document">
                    <div class="modal-content o-common-modal-content">                    
                        <div class="modal-header text-center">
                            <button @click="openCloseJobInfoModal('close', null)" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 class="modal-title" v-if="selectedJob">Event: {{selectedJob.title}}</h1>
                        </div>

                        <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender" v-if="selectedJob">
                            <!-- <p>{{ selectedJob.venue }}</p> -->
                            <form>
                            <div class="row">
                                <div class="col-sm-12 o-no-padding o-calender-container">
                                    <div class="col-md-5 o-right-no-padding o-calender-area">
                                        <div class="o-calls-table">
                                            <div class="o-calender-details-list">
                                                <ul>
                                                    <li><strong>Job No.</strong> <span>#{{selectedJob.job_number}}</span></li>
                                                    <li><strong>Steward:</strong> <span>{{selectedJob.employee && selectedJob.employee.employable?selectedJob.employee.employable.first_name+" "+selectedJob.employee.employable.last_name:''}}</span></li>
                                                    <li><strong>Dispatched by:</strong> <span>{{selectedJob.created_by ? selectedJob.created_by.first_name+' '+selectedJob.created_by.last_name:''}}</span></li>
                                                    <li><strong>Start Date:</strong> <span>{{getDate(selectedJob.start)}}</span></li>
                                                    <li><strong>End Date:</strong> <span>{{getDate(selectedJob.end)}}</span></li>
                                                    <li><strong>Employer:</strong> <span>{{selectedJob.employer?selectedJob.employer.name:''}}</span></li>
                                                    <li><strong>Payroll:</strong> <span>---</span></li>
                                                </ul>
                                            </div>
                                           
                                            <div class="o-calender-wishlist">
                                                <a  @click="viewCalendarCall(selectedJob.id)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-yellow">View calls</a>
                                            </div>                                           
                                            

                                            <!-- <div class="o-calender-wishlist" v-if="(wishlist_lock || ignorelist_lock) && checkWishAccess(modal_event.end)">
                                                <div v-if="wishlist_lock" class="radio o-custom-radio">
                                                    <label>
                                                        Wished
                                                        <input type="radio" name="o5" value="W" v-model="wishStatus" @change="changeStatus()">
                                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                    </label>
                                                </div>
                                                <div v-if="ignorelist_lock" class="radio o-custom-radio">
                                                    <label>
                                                        Ignored
                                                        <input type="radio" name="o5" value="I" v-model="wishStatus" @change="changeStatus()">
                                                        <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                    </label>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div class="col-md-7 o-calender-area">
                                        
                                        <div class="custom-row u-common-box-shadow c-radius3">
                                            <div class="o-calls-table">
                                                <div class="o-common-head">
                                                    <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> 
                                                        Venue: {{ full_address_map }}
                                                    </h5>
                                                </div>
                                                <div class="o-map-conatiner">
                                                    <iframe                                                        
                                                        v-if="getMapUrl()"
                                                        width="100%"
                                                        height="100%"
                                                        frameborder="0" style="border:0"
                                                        :src="getMapUrl()" allowfullscreen>
                                                    </iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                
                                <div class="col-sm-12 o-no-padding o-calender-container" style="margin-top: 10px;">
                                    <div class="col-md-12 o-right-no-padding o-calender-area" >
                                    <ul class="o-filter-area make-parent-full-width">
                                        <li v-if="selectedJob.employer_requests_private==0" class="make-parent-full-width"><strong>Employer Request:</strong> 
                                            <span v-html="selectedJob.employer_requests"></span>
                                        </li>
                                        
                                        <li v-if="selectedJob.comment_private==0" class="make-parent-full-width"><strong>Comment:</strong> 
                                            <span v-html="selectedJob.comment"></span>
                                        </li>
                                    </ul>  
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 o-no-padding">
                                <div class="col-md-12">
                                    <h5 class="h2">Documents:</h5>
                                </div>
                                <div v-if="selectedJob && selectedJob.report && selectedJob.report.length>0" class="col-md-12">
                                    <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3 no-margin-top">
                                        <ul class="o-documents-container" id="document-ul">
                                            <li v-for="(attachment, key, index) in selectedJob.report" :key="index" class="document-exist">
                                                <div v-if="attachment.shareable">
                                                    <div class="col-md-4 o-no-padding o-uploaded-doc">
                                                        <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{ snippet(attachment.filename) }}
                                                    </div>
                                                    <div class="col-md-8 o-no-padding text-right o-uploaded-doc-owner">
                                                        <div class="o-inlineblock o-attachmentdate created-time-width">
                                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(attachment.created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(attachment.created_at)}}
                                                        </div>
                                                        <div class="o-inlineblock text-right action-icon-doc-width">
                                                            <h5>
                                                                Created by: {{ getNoteAuthor(attachment) }} 
                                                                <a @click="copyDocumentLink(attachment.path)"><i class="fa fa-copy"></i></a>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                </div>
                            </div> 

                            </form>
                        </div>

                        <div class="modal-footer text-center">
                        </div>

                    </div>
                </div>
            </div>

             
                    <!-- /.modal-content -->
                <!-- /.modal-dialog -->
        </modal>

        <modal name="add-note-callout-decline" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom" @closed="openCloseAddNoteModal('close', null)">
            <div tabindex="-1" role="dialog" >
                <div role="document">
                    <div class="modal-content">                    
                        <div class="modal-header text-center">
                            <button @click="openCloseAddNoteModal('close', null)" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 class="modal-title" v-if="selectedJob">Add Note </h1>
                        </div>

                        <div class="modal-body mt-15" v-if="addNoteDialog">
                            <!-- <p>{{ selectedJob.venue }}</p> -->
                            <form>
                            <div class="row">
                                <div class="col-sm-12 o-no-padding">
                                    <div class="col-md-5 o-right-no-padding o-calender-area">
                                        <div class="o-calls-table">
                                            <div class="o-calender-details-list">
                                                <el-form :model="addNoteDialogForm">
                                                    <el-form-item label="Note">
                                                    <el-input v-model="addNoteDialogForm.note" autocomplete="off"></el-input>
                                                    </el-form-item>
                                                </el-form>
                                            </div>                                           
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            </form>
                        </div>

                        <div class="modal-footer text-center">
                             <span slot="footer" class="dialog-footer">
                                <el-button @click="openCloseAddNoteModal('close', null)">Cancel</el-button>
                                <el-button type="primary" :disabled="disabled" @click="performCallOutDeclineActions(callData, addNoteDialogForm.note)">{{ action }}</el-button>
                            </span>
                        </div>

                    </div>
                </div>
            </div>

             
                    <!-- /.modal-content -->
                <!-- /.modal-dialog -->
        </modal>

        <modal name="otbConflictPop"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
            <div  tabindex="-1" role="dialog">
               <div  role="document">
                   <div class="modal-content o-common-modal-content otb-modal-content">
                       <div class="modal-header text-center">
                           <button @click="closeOtbConflictPop()" type="button" class="close otb-close custom-modal--close otb-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                           <h1 class="modal-title otb-title">WARNING !</h1>
                       </div>
                       <div class="modal-body">
                               <div class="otb-conflict-body">
                                    'You are already confirmed on this day in another client!'
                                    'Before you confirm this call, contact the other jurisdiction for permission.
                                    'Confirming this call will automatically notify dispatch in another jurisdiction of a cleared confirmation!
                               </div>   
                        </div>                        

                        <div class="modal-footer text-center">
                           <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="closeOtbConflictPop()" class="c-common-btn c-common-btn--small otb-modal-cancel-btn"> Cancel</a>
                           <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="proceedWithConflict(selectedCall)" class="c-common-btn c-common-btn--small otb-modal-proceed-btn">Proceed</a>
                        </div>
                   
                   </div>
                   <!-- /.modal-content -->
               </div>
               <!-- /.modal-dialog -->
           </div>
        </modal>  
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import dateTimeConvert from '@/timeConvert&Compare';
    import service from '@/services.js';
    export default {
        props: {
            routeEmployeeId: {
                type: String,
                required: true
            },
            // userSelectMonth: {
            //     type: String,
            //     required: true
            // },
            employeeUserId:{
                type: String,
                required:true
            },
            scheduleData:{
                type: Object,
                required:true
            },
            userDateFormat: {
                type: String,
                required:false
            },
            userTimeFormat: {
                type: String,
                required:false
            },
            // subTab:{
            //     type: String,
            //     required:true
            // }
        },
        
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug: 'userRoleSlug',
                userID: 'userID',
                subDomain: 'getSubdomain',
                employeeId: 'employeeId',
                userName: "userName",
                userFirstName: "userFirstName",
                userFullName: "userFullName",
            }),
            // selectedJob() {
            //     if(this.tempSelectedJob) {
            //         return tempSelectedJob
            //     }
            //     return null
            // }

        },

        data() {
            return {
                tab: "scheduled",
                callData: null,
                addNoteDialog: false,
                addNoteDialogForm: {
                    note: ''
                },
                action: null,
                loading:false,
                afterAPI:false,
                scheduleList: [],
                selectedMonth: moment().month()+1,//new Date().getMonth() + 1,
                selectedYear: moment().year(), // new Date().getFullYear(),
                full_address_map:'',
                internetConfirm:true,
                pass_option:true,
                userId: '',
                // selectedJob:'',
                callTimeOut:'',
                selectedJob:null,
                // tempSelectedJob: null,
                modalEventOpenStatus: false,
                modalLocationOpenStatus: false,
                selectedCall: null,
                disabled: false,
                display_rate: false
            }
        },

        watch: {
            scheduleData: function(newData){
                this.scheduleList = [];
                if(newData.subTab=='month'){
                    this.selectedMonth = moment(newData.month).month()+1;//newData.getMonth() + 1;
                    this.selectedYear = moment(newData.month).year(); //newData.getFullYear();
                    this.getScheduleByMonth();
                }else{
                    this.getNext45DaySchedule();
                }
                // console.log(newData);
            },
            
            employeeUserId: function(newData){
                this.userId=newData;
            },

            // subTab: function(newData){
            //     // this.subTab=newData;
            //     console.log(newData);
            //     if(newData=='month'){
            //         this.getScheduleByMonth();
            //     }else{
            //         this.getNext45DaySchedule();
            //     }
            // }

            // userSelectMonth: function(newData) {
            //     console.log(newData);
            //     this.scheduleList = [];
            //     //console.log(this)
            //     this.selectedMonth = moment(newData).month()+1;//newData.getMonth() + 1;
            //     this.selectedYear = moment(newData).year(); //newData.getFullYear();
            //     //console.log(this.selectedMonth,this.selectedYear);
            //     this.getScheduleByMonth();
            // },
            
        },

        async created() {
            this.selectedMonth =moment(this.scheduleData.month).month()+1; // this.userSelectMonth.getMonth() + 1;
            this.selectedYear = moment(this.scheduleData.month).year(); //this.userSelectMonth.getFullYear();
            this.loading=true;
            this.afterAPI=false;
            
            await this.getClientDetails();

            await this.getEmployeeDetails();

            if(this.scheduleData.subTab=='month'){
                this.getScheduleByMonth();
            }else{
                this.getNext45DaySchedule();
            }            
            //console.log('Employee Uder Id', this.employeeUserId);
        },

        methods: {
            snippet(value) {
                let tempArray = [];
                if (value.length > 20)
                    tempArray = value.slice(0, 20) + '  ...';
                    // return value.slice(0, 20) + '  ...';
                else
                    tempArray = value;
                return tempArray;
            },
            getDateUtc(str) {
                return dateTimeConvert.dateFromUtc(str);
            },
            getTimeUtc(dateTime) {
                return dateTimeConvert.timeFromUtc(dateTime);
            },

            openCloseJobInfoModal(type, job){
                this.modalEventOpenStatus = true;
                this.selectedJob = job;
                if(type == 'open' && this.selectedJob){
                    this.modalEventOpenStatus = true;
                    // console.log(this.selectedJob)
                    this.$modal.show("calender-job-details");
                }else{
                    this.modalEventOpenStatus = false;
                    this.$modal.hide("calender-job-details");
                }
            },
            copyDocumentLink(link){
            //   console.log(link);
              var textarea = document.createElement("textarea");
              textarea.textContent = link;
              textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
              document.body.appendChild(textarea);
              textarea.select();
              try {
                // console.log(textarea);
                  document.execCommand("copy");  // Security exception may be thrown by some browsers.
                  this.$notify({
                          title: this.$t('success'),
                          message: 'link copied to clipboard.',
                          type: 'success'
                      });
                      setTimeout(()=>{ 
                        // window.location.href=link;
                        window.open(link, '_blank');
                    }, 2000);
                      
              } catch (ex) {
                  console.warn("Copy to clipboard failed.", ex);
                  return false;
              } finally {
                  document.body.removeChild(textarea);
              }
            },
            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if (getAuthor.uploader_id == this.userId) {
                    return "Me";
                } else {
                    return getAuthor.uploaded_by;
                }
            },            
            viewCalendarCall(id){
              this.$modal.hide("calender-job-details");
              this.$router.push({
                  path: `/calendarJobCall/`+btoa(id)
              });
            },
            getPower(data) {
                // return false;
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                if(dateTimeConvert.checkAccess(data)){
                    // console.log('userRoleSlug', this.userRoleSlug);
                    if(this.userRoleSlug == 'auditor'){
                        if(this.routeEmployeeId == this.employeeId){
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
                return false;
            },
            getAddressText(venue){
                let addTxt="";
                if(venue && venue.addresses){
                    addTxt =venue.name;
                    if(venue.addresses.length){
                        addTxt =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
                    }
                }
                return addTxt;
            },
            getMapUrl(){
                let venue = this.selectedJob.venue;
                let tempAddressMap = this.selectedJob.venue;
                if(venue && venue.addresses){
                    tempAddressMap = venue.name;
                    if(venue.addresses.length){
                        tempAddressMap = venue.name + ", " + venue.addresses[0].address + ", " + venue.addresses[0].municipality +", " + venue.addresses[0].postcode +", " + venue.addresses[0].state_province + ", " + venue.addresses[0].country;
                    }
                }
                this.full_address_map = tempAddressMap;

				return dateTimeConvert.getMapUrl(tempAddressMap);
			},            
            getCallOutTime(date){
                // console.log('callTimeOut',this.callTimeOut);
                if(this.callTimeOut!=null && this.callTimeOut!="" && this.callTimeOut!="00:00"){
                    let callOutafter=(Number(this.callTimeOut.split(':')[0]*60) + Number(this.callTimeOut.split(':')[1]));
                    // console.log('refresh Time',callOutafter/60);
                    let b=moment.utc(date).tz(this.$cookies.get('time_zone')).format(this.userDateFormat + ' ' + this.userTimeFormat);
                    var dt = new Date(b);
                    dt.setMinutes( dt.getMinutes() + callOutafter);
                    //console.log(callOutafter, b ,dt);
                    if(dt>new Date(b)){
                        return moment(dt).format(this.userDateFormat + ' ' + this.userTimeFormat);
                    }else
                        return "---";
                }else
                    return "---";
                // let callOutAt=moment(b).add(callOutafter, 'minutes').calendar();
                // // if(new Date(callOutAt)> new Date()){
                // console.log(date,callOutAt);
                // // }
                // if(new Date()>new Date(callOutAt))
                // return callOutAt;


                // let constTime= "4:30"
                // let b=moment.utc(date).tz(this.$cookies.get('time_zone')).format('YYYY-MM-DD HH:mm:ss');
                // let a=Number((constTime.split(':')[0])*60) + Number(constTime.split(':')[0]);
                // let now = moment(new Date());
                // let assignAt= moment(b);
                // let diff =now.diff(assignAt, 'seconds');
                // console.log(a*60,diff, b);
                // if((a)>diff)
                //     return (Math.round(diff/3600) +':'+Math.round((diff%3600)/60)+":"+Math.round((diff%3600)%60));
                // else
                //  return '00:00:00';
            },
            openMap(job){
                //console.log(job); 
                // this.selectedJob = job               
                this.$modal.show("calender-details");
            },
            closeMap() {
                // this.selectedJob = null; 
                this.$modal.hide("calender-details");
            },
            getDate(str) {
                return dateTimeConvert.localDate(str,this.userDateFormat);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime,this.userTimeFormat);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            // getDate(dateTime){
            //     var date = dateTimeConvert.extractDateOnly(dateTime);
            //     return dateTimeConvert.extractDateOnly(dateTime);
            // },
            confirmCall(call) {
                this.$confirm('Are you sure you would like to Confirm this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    //console.log(call);
                    this.$Progress.start();
                    service.put('call/' + call.id + '/confirm', {
                        user_id: this.userID, //this.userId
                        logged_in_employee_id: this.employeeId,
                        page: 'schedule'
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then(async(res) => {
                        this.$Progress.finish();
                        if(res.data.status_code == "0") {
                            this.$notify({
                                title: 'Error',
                                message: res.data.status_message,
                                type: 'error'
                            });
                        } else {
                            this.$notify.success({
                                title: this.$t('success'),
                                message: 'Call confirmed successfully.'
                            });
                        }
                        // console.log(document.body.classList);
                        if(this.scheduleData.subTab=='month'){
                            await this.getScheduleByMonth();
                        }else{
                            await this.getNext45DaySchedule();
                        }      
                        document.body.classList.length = 0;
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch(() => {

                });
            },

            passCall(call) {
                this.$confirm('Are you sure you would like to pass this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.put('call/' + call.id + '/pass', {
                        user_id: this.userID, // this.userId
                        logged_in_employee_id: this.employeeId,
                        page: 'schedule'
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then(async (res) => {
                        this.$Progress.finish();
                        if(res.data.status_code == "0") {
                            this.$notify({
                                title: 'Error',
                                message: res.data.status_message,
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                title: this.$t('success'),
                                message: this.$t('call_passed_success'),
                                type: 'success'
                            });
                        }
                        // this.$notify({
                        //     title: this.$t('success'),
                        //     message: 'Call passed successfully.',
                        //     type: 'success'
                        // });
                        if(this.scheduleData.subTab=='month'){
                            await this.getScheduleByMonth();
                        }else{
                            await this.getNext45DaySchedule();
                        }
                        document.body.classList.length = 0;
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch((error) => {
                    console.log(error);
                });
            },

            declineCall(call) {
                this.action = 'Decline'
                // console.log(call);
                this.$confirm('Are you sure you would like to decline this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(async() => {
                    this.addNoteDialog = true;
                    this.openCloseAddNoteModal('open', call);
                    //  this.$confirm('Please input your Note', 'Note', {
                    //     confirmButtonText: 'OK',
                    //     cancelButtonText: 'Cancel',
                    //     showInput: true,
                    //     appendToBody: true,
                    //     inputErrorMessage: 'Invalid Email'
                    //     }).then(async({value}) => {
                    //         this.addNoteDialog = true;
                            
                    //         var activityID = {
                    //         "uploader_id": this.userID,
                    //         "uploaded_by": this.userFullName,
                    // };
                    // activityID = JSON.stringify(activityID);
                    // service.put('call/' + call.id + '/decline', {
                    //     user_id: this.userID,//this.userId
                    //     'activity': activityID,
                    //     'note_content': value,
                    // }, {
                    //     'Authorization': this.userToken,
                    //     'cs3-context-role': this.userRole,
                    //     'cs3-context-clientId': this.userClientID,
                    // }).
                    // then((res) => {
                    //     this.$Progress.finish();
                    //     this.$notify({
                    //         title: this.$t('success'),
                    //         message: 'Call declined successfully.',
                    //         type: 'success'
                    //     });
                    //     if(this.scheduleData.subTab=='month'){
                    //         this.getScheduleByMonth();
                    //     }else{
                    //         this.getNext45DaySchedule();
                    //     }
                    // }).catch((err) => {
                    //     console.log(err);
                    //     this.$Progress.finish();
                    // });

                            // console.log(call, value);
                            // await this.openAddNotePromptDecline(call,value);
                        // }).catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: 'Decline canceled'
                        // });       
                    // });  
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Declined canceled'
                    });
                });
            },

            openCloseAddNoteModal(type, call){
                this.addNoteDialog = true;
                this.callData = call;
                if(type == 'open'){
                    this.addNoteDialog = true;
                    // console.log(this.selectedJob)
                    this.$modal.show("add-note-callout-decline");
                }else{
                    this.addNoteDialog = false;
                    this.$modal.hide("add-note-callout-decline");
                }
            }, 
            
            async openAddNotePromptDecline(call,value) {
                // console.log(call);
                this.disabled = true;
                 var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                // console.log(call.id,value, {activityID});
                await service.put('call/' + call.id + '/decline', {
                        user_id: this.userID,//this.userId
                        logged_in_employee_id: this.employeeId,
                        page: 'schedule',
                        'activity': activityID,
                        'note_content': value,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then(async (res) => {
                        this.disabled = false;
                        this.$Progress.finish(); 
                        if(res.data.status_code == "0") {
                            this.$notify({
                                title: 'Error',
                                message: res.data.status_message,
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                title: this.$t('success'),
                                message: this.$t('call_declined_success'),
                                type: 'success'
                            });
                        }                       
                        // this.$notify({
                        //     title: this.$t('success'),
                        //     message: 'Call declined successfully.',
                        //     type: 'success'
                        // });
                        if(this.scheduleData.subTab=='month'){
                            await this.getScheduleByMonth();
                        }else{
                            await this.getNext45DaySchedule();
                        }
                        this.addNoteDialog = false;
                        this.$modal.hide("add-note-callout-decline");
                        this.addNoteDialogForm.note = "";
                        document.body.classList = [];
                    }).catch((err) => {
                        this.disabled = false;
                        console.log(err);
                        this.$Progress.finish();
                    });
            },

            callOut(call) {
                //console.log(call);
                this.action = "Callout"
                this.callData = call
                this.$confirm('Do you want to called out?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.addNoteDialog = true;
                    this.openCloseAddNoteModal('open', call);

                //     this.$confirm('Please input your Note', 'Note', {
                //         confirmButtonText: 'OK',
                //         cancelButtonText: 'Cancel',
                //         showInput: true,
                //         appendToBody: true,
                //         inputErrorMessage: 'Invalid Note'
                //         }).then(async({value}) => {

                //             // console.log(call.id);
                // var activityID = {
                //     "uploader_id": this.userID,
                //     "uploaded_by": this.userFullName,
                // };
                // activityID = JSON.stringify(activityID);
                // console.log(call.id,value, {activityID});
                // await service.post('call/' + call.id + '/callout', {
                //         user_id: this.userID,//this.userId
                //         activity: activityID,
                //         note_content: value,
                //     }, {
                //         'Authorization': this.userToken,
                //         'cs3-context-role': this.userRole,
                //         'cs3-context-clientId': this.userClientID,
                //     }).
                //     then((res) => {
                //         this.$Progress.finish();
                //         this.$notify({
                //             title: this.$t('success'),
                //             message: 'Called Out successfully.',
                //             type: 'success'
                //         });
                //         this.$router.push({
                //             path: "/viewCalls/"+btoa(call.job_id)
                //         });
                //     }).catch((err) => {
                //         console.log(err);
                //         this.$Progress.finish();
                //     });


                            // console.log(value);
                            // await this.openAddNotePromptCallOut(call,value);
                    //     }).catch(() => {
                    //     this.$message({
                    //         type: 'info',
                    //         message: 'Decline canceled'
                    //     });       
                    // });                   
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Called Out canceled'
                    });
                });
            },

            async openAddNotePromptCallOut(call,value) {
                // console.log(call.id);
                this.disabled = true;
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                // console.log(call.id,value, {activityID});
                await service.post('call/' + call.id + '/callout', {
                        user_id: this.userID,//this.userId
                        activity: activityID,
                        note_content: value,
                    }, {
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.disabled = false;
                        this.$Progress.finish();
                        this.addNoteDialog = false;
                        this.$modal.hide("add-note-callout-decline");
                        this.addNoteDialogForm.note = "";
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Called Out successfully.',
                            type: 'success'
                        });
                        document.body.classList = [];
                        this.$router.push({
                            path: "/viewCalls/"+btoa(call.job_id)
                        });
                    }).catch((err) => {
                        this.disabled = false;
                        console.log(err);
                        this.$Progress.finish();
                    });
            },

            async performCallOutDeclineActions(call,value) {
                if(this.action == 'Decline') {
                    await this.openAddNotePromptDecline(call,value);
                }
                if(this.action == 'Callout') {
                    await this.openAddNotePromptCallOut(call,value);
                }
            },

            findCarpool(call) {
                //console.log(call);
            },

            async clearAssign(call){
                this.$confirm('Are you sure you would like to clear this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(async () => {
                    await service.del('call/' + call.id + '/assign', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'userId': this.userID
                    }).
                    then(async (res) => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call cleared successfully.',
                            type: 'success'
                        });
                        if(this.scheduleData.subTab=='month'){
                            await this.getScheduleByMonth();
                        }else{
                            await this.getNext45DaySchedule();
                        }
                        this.openCloseAddNoteModal('close', null);
                        this.$modal.hide("add-note-callout-decline");
                        document.body.classList = [];
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    
                });
            },

            async getScheduleByMonth() {
                document.body.classList = [];
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                await service.get('call/employeeCallsByMonth', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.routeEmployeeId,
                    'month': this.selectedMonth,
                    'year': this.selectedYear,
                    'role-id': this.userRole,
                    'user-id': this.userId,
                    'flag': 'mua'
                }).
                then((res) => {
                    this.scheduleList = res.data.result;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                    //console.log(this.scheduleList);
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                });
            },

            async getNext45DaySchedule() {
                document.body.classList = [];
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                await service.get('call/employeeCallsByNext45Days', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.routeEmployeeId,
                    'role-id': this.userRole,
                    'user-id': this.userId,
                    'flag': 'mua'
                }).
                then((res) => {
                    this.scheduleList = res.data.result;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                });
            },

            onHidden() {
                document.body.classList = [];
                this.selectedJob = null;
            },
            // beforeEventModalOpen(obj) {
            //     console.log("Open");            
            // },
            // beforeLocationModalOpen(event) {
            //     console.log("Open");
            // }

            checkOtherBookingConflict(call) {
                let status = false;
                if(call.mua_booking_conflict&&call.mua_booking_conflict.length) {
                    this.selectedCall = call;
                    this.$modal.show("otbConflictPop");
                } else {
                    this.selectedCall = null;
                    this.confirmCall(call);
                }
            },

            closeOtbConflictPop() {                
                this.$modal.hide("otbConflictPop");
            },

            proceedWithConflict(call){
                this.confirmCall(call);
                this.$modal.hide("otbConflictPop");
            },

            async getClientDetails() {
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).then((res) => {
                    //this.turnoverTime=res.data.result.turnover;
                    this.callTimeOut=res.data.result.phonesheet_ts;
                    if(res.data.result.pass_option == 1){
                        this.pass_option=false;
                    }else{
                        this.pass_option=true;
                    }   
                    if (res.data.result.internet_confirm == 1) {
                        this.internetConfirm = false
                    } else {
                        console.log(this.userRoleSlug);
                        if(this.userRoleSlug=='client-admin'||this.userRoleSlug=='power-user') {
                            this.internetConfirm = false;
                        } else {
                            this.internetConfirm = true;
                        }
                        // this.internetConfirm = true;
                    }
                    if(res.data.result.display_rate == 1) {
                        this.display_rate = true;
                    }else {
                        this.display_rate = false;
                    }
                    // this.getNext45DaySchedule();
                }).catch((err) => {
                    this.loading=false;
                    this.afterAPI=true;
                    console.log(err);
                });
            },
            
            async getEmployeeDetails() {
                await service.get('employee/' + this.routeEmployeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.userId=res.data.result.employable.id;
                    //console.log('UserID',this.userId);
                    // console.log(res);
                }).catch((err) => {
                    this.loading=false;
                    this.afterAPI=true;
                    console.log(err);
                });
            },

            checkCallClientAndLoggedInUserClient(callClient) {
                let result = false;
                result = callClient == this.userClientID;
                return result;
            }
            
        },
    }

</script>

<style>

.otb-flag {
    background-color: #FB8B03;
    color: #000000;
    font-size: 12px;
    font-weight: 500;
    padding: 5px;
    margin: 2px;
    height:15px;
    width:20px;
}
.otb-modal-content {
    border-radius: 3px !important;
    padding: 0px!important;
    background-color: #ffffff;
    border: 2px solid #000000!important;
}

.otb-title {
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    background-color: #F67801;
    border-bottom: 2px solid #000000;
}

.otb-close {
    text-shadow: 0 0 0 #000000!important;
    font-size: 15px;
}

.otb-modal--close {
    opacity: 1;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    background-color: #F67801!important;
    color: #000000!important;
    padding: 0 !important;
    text-shadow: #000000!important;
    margin-top: 0;
}

.otb-modal-cancel-btn {
    background-color: #F67801;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.otb-modal-proceed-btn {
    background-color: #17A068;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.otb-conflict-body {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 10px 0;
}



.schedule-list-table-align .calls-table-row .calls-table-cell:nth-child(6) {
    width: 165px;
}
.mt-15{
    margin-top: 15px;
}
.notes-scroll-view-style{
    overflow-y: scroll;
    max-height: 60px;
}
</style>
